module.exports = __webpack_public_path__ + "static/media/reports_deposit-record.4be1d82f.svg";